<template>
  <div>
    <div class="work-center-header" v-if="workCenters.length > 0">
      {{ $t("work_center_planning.work_center") }}
      <span>{{ workCenter }}</span>
      <span class="navigation-menu">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-icon large v-on="on">arrow_drop_down</v-icon>
          </template>
          <v-list>
            <v-list-tile
              v-for="(workCenter, index) in workCenters"
              :key="index"
              @click="changeWorkCenter(workCenter)"
            >
              <v-list-tile-title>{{ workCenter }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </span>
      <v-checkbox
        class="show-done"
        :label="'Rodyti užbaigtus'"
        v-model="finished"
      ></v-checkbox>
      <div class="export-button" @click="exportPdf">
        <v-icon color="red" large v-tooltip="$t('work_center_planning.list')"
          >print</v-icon
        >
      </div>
      <div class="position-export-button" @click="exportPositionPdf">
        <v-icon
          color="blue"
          large
          v-tooltip="$t('work_center_planning.position_list')"
          >print</v-icon
        >
      </div>
      <div class="complete-orders-button" @click="completeOrders">
        <v-icon
          :disabled="selected.length == 0"
          color="blue"
          large
          v-tooltip="$t('work_center_planning.complete_orders')"
          >done_all</v-icon
        >
      </div>
    </div>
    <input
      class="workcenter-filter"
      type="text"
      :placeholder="'Filtras'"
      v-model="filter"
      @input="isChangingFilter = true"
    />
    <div class="rTable">
      <div class="rTableRow">
        <div class="rTableHead">
          <input
            id="preperation-select-all"
            type="checkbox"
            @input="selectAll($event.target.checked)"
          />
        </div>
        <div class="rTableHead" v-for="(header, i) in headers" :key="i">
          {{ header.text }}
        </div>
      </div>
      <div
        class="rTableRow order-row"
        v-for="(row, i) in rows"
        :key="i"
        :class="getClass(row)"
      >
        <div
          class="rTableCell"
          v-for="(cell, j) in row.cells"
          :key="j"
          :class="cell.style"
          @click="toggle(row, cell)"
          @mouseenter="preview($event, cell, row)"
        >
          <span v-if="cell.number == -1 && row.getType() == 'order'">
            <input
              class="preperation-checkbox"
              type="checkbox"
              @input="selectOrder($event.target.checked, row.object)"
            />
          </span>
          <span v-else-if="cell.text != 'complete'">{{ cell.text }}</span>
          <span v-else>
            <v-icon class="mr-2" @click="complete(row)">add</v-icon>
            <v-icon
              class="mr-2"
              v-if="row.type == 'product'"
              @click="openCommentDialog(row)"
              >comment</v-icon
            >
            <v-icon
              class="mr-2"
              v-if="row.type == 'product'"
              @click="openReturnDialog(row)"
              >keyboard_return</v-icon
            >
          </span>
        </div>
      </div>
    </div>
    <div class="text-xs-center">
      <v-pagination v-model="page" :length="pages"></v-pagination>
    </div>

    <OperationCommentDialog
      :workCenterId="workCenterId"
      ref="returnDialog"
      @commentWritten="initialize"
      @operationsReturned="initialize"
    />
    <CommentsPreviewDialog
      ref="commentsPreviewDialog"
      @commentCreated="initialize"
    />
  </div>
</template>

<script>
import Export from "@/models/Export.js";
import Helper from "@/models/Helper.js";
import Row from "@/models/WorkCenterTableRow.js";
import WorkCenter from "@/models/WorkCenter.js";
import Product from "@/models/Product.js";
import OperationCommentDialog from "@/components/production-planning/OperationCommentDialog.vue";
import CommentsPreviewDialog from "@/components/production-planning/CommentsPreviewDialog";
export default {
  data() {
    return {
      page: 1,
      pages: 1,
      finished: false,
      filter: "",
      rows: [],
      workCenters: [],
      workCenter: {},
      dialog: false,
      isChangingFilter: false,
      filterTimer: 0,
      headers: [
        {
          text: this.$t("work_center_planning.order"),
          value: "name",
        },
        {
          text: this.$t("work_center_planning.customer"),
          value: "customer",
        },
        {
          text: this.$t("work_center_planning.products_count"),
          value: "products_count",
        },
        {
          text: this.$t("work_center_planning.remaining_products_count"),
          value: "remaining_products_count",
        },
        {
          text: this.$t("work_center_planning.products_area"),
          value: "products_area",
        },
        {
          text: this.$t("work_center_planning.time_left"),
          value: "time_left",
        },
        {
          text: this.$t("work_center_planning.actions"),
          value: "actions",
        },
      ],
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: -1,
      },
      orders: [],
      selected: [],
      selectedProduct: null,
      mouseIsOver: -1,
      workCenterId: this.$route.params.id,
    };
  },

  async created() {
    this.workCenters = await WorkCenter.loadCenters();
    this.updateWindow();
  },

  watch: {
    isChangingFilter(val) {
      if (!val) {
        this.changeFilter();
      }
    },
    filter() {
      clearTimeout(this.filterTimer);
      this.filterTimer = setTimeout(() => {
        this.isChangingFilter = false;
      }, 500);
    },
    mouseIsOver(val) {
      if (val == -1 && this.selectedProduct != null) {
        this.selectedProduct = null;
        this.$emit("hideProduct");
      }
    },
    finished() {
      this.initialize();
    },
    page() {
      this.initialize();
    },
  },

  destroyed() {
    this.$destroy();
  },

  methods: {
    async updateWindow() {
      // eslint-disable-next-line
      while (true) {
        this.initialize();
        await Helper.timeout(30000);
      }
    },

    changeFilter() {
      this.page = 1;
      this.initialize();
    },

    async initialize() {
      if (!this.$route.params.id) {
        return;
      }
      this.workCenter = this.getWorkCenter(this.workCenters);
      const { orders, pages } = await WorkCenter.loadWorkCenterPlan(
        this.$route.params.id,
        this.orders,
        this.filter,
        this.finished,
        this.page,
        this.workCenter.preperation
      );
      this.orders = orders;
      this.pages = pages;
      this.rows = Row.getRows(
        this.orders,
        this.headers,
        this.$route.params.id,
        this.workCenter.preperation
      );
    },

    getWorkCenter(workCenters) {
      return workCenters.find((e) => {
        return e.id == this.$route.params.id;
      });
    },

    async endOperations(order) {
      await order.endOperations(this.workCenterId);
      alert(
        `${this.$t(
          "work_center_planning.order_operations_finished"
        )}: ${order.toString()}`
      );
      this.initialize();
    },

    toggle(row, cell) {
      const object = row.object;
      if (cell.number == -1) return;
      if (cell.number == 6) return;
      if (!object) return;
      if ("count" in object) {
        const orderIndex = this.orders.indexOf(object);
        this.orders[orderIndex].showProducts = !this.orders[orderIndex]
          .showProducts;
        this.rows = Row.getRows(
          this.orders,
          this.headers,
          this.$route.params.id,
          this.workCenter.preperation
        );
      } else {
        if (cell.number != 3) return;
        this.openCommentDialog(row, true);
      }
    },

    async complete(row) {
      const products = this.getRowProducts(row);
      const confirmed = confirm(
        this.$t("work_center_planning.complete_prompt") + "?"
      );
      if (!confirmed) return;
      await Product.endOperations(this.$route.params.id, products);
      this.initialize();
    },

    async completeOrders() {
      let products = [];
      this.selected.forEach((order) => {
        products = [...products, ...order.products];
      });
      const confirmed = confirm(
        this.$t("work_center_planning.complete_prompt") + "?"
      );
      if (!confirmed) return;
      await Product.endOperations(this.$route.params.id, products);
      this.selectAll(false);
      this.initialize();
    },

    /**
     *  opens comment dialog with operation comments
     * @param row - selected row (representing order or product)
     * @param onlyProblems - bool, showing if check operation status
     */
    openCommentDialog(row, onlyProblems) {
      const object = row.object;
      const workCenterId = this.workCenterId;
      const comments = row.object.getPreviewComments(workCenterId);
      const operation = object.getWorkCenterOperation(workCenterId);
      if (operation) {
        if (onlyProblems) if (operation.status != 3) return;
        this.$refs.commentsPreviewDialog.open(comments, operation);
      }
    },

    openReturnDialog(row) {
      const products = this.getRowProducts(row);
      this.$refs.returnDialog.openReturn(products);
    },

    getRowProducts(row) {
      let products = [];
      if ("offer_id" in row.object) {
        products = row.object.products;
      }
      if (Object.keys(row.object).length == 1 && "products" in row.object) {
        products = row.object.products;
      }
      if ("x" in row.object) {
        products = [row.object];
      }
      return products;
    },

    exportPdf() {
      Export.productionExport(this.$route.params.id);
    },

    exportPositionPdf() {
      Export.productionPositionExport(this.$route.params.id);
    },

    changeWorkCenter(workCenter) {
      this.$router
        .replace({ name: "work-center", params: { id: workCenter.id } })
        .catch(() => {});
      this.initialize();
    },

    preview(e, cell, row) {
      if (cell.number == 1 && row.type == "product") {
        row.object.select(this);
      }
    },

    previewClose() {
      this.$refs.commentsPreviewDialog.close();
    },

    /**
     * checks how to display row
     * @param row - row we are checking
     */
    getClass(row) {
      if (row.type === "order") {
        return {
          clickable: true,
        };
      }
      if (row.type === "product") {
        return {
          "products-column": true,
        };
      }
    },

    selectAll(checked) {
      const mainCheckbox = document.getElementById("preperation-select-all");
      if (mainCheckbox) {
        mainCheckbox.checked = checked;
      }
      const checkboxes = document.getElementsByClassName(
        "preperation-checkbox"
      );
      for (const row of this.rows) {
        if (row.getType() == "order") {
          this.selectOrder(checked, row.object);
        }
      }
      for (const checkbox of checkboxes) {
        checkbox.checked = checked;
      }
    },

    selectOrder(checked, order) {
      if (checked) {
        this.addSelected(order);
      } else {
        this.removeSelected(order);
      }
    },

    addSelected(order) {
      this.selected.push(order);
    },

    removeSelected(order) {
      const removeIndex = this.selected
        .map((e) => {
          return e.id;
        })
        .indexOf(order.id);
      if (removeIndex != -1) {
        this.selected.splice(removeIndex, 1);
      }
    },
  },

  components: {
    OperationCommentDialog,
    CommentsPreviewDialog,
  },
};
</script>

<style scoped>
.rTable {
  display: table;
  width: 100%;
}
.rTableRow {
  display: table-row;
}
.rTableHeading {
  display: table-header-group;
  background-color: #ddd;
}
.rTableCell,
.rTableHead {
  display: table-cell;
  padding: 3px 10px;
  border: 1px solid #999999;
}
.rTableHeading {
  display: table-header-group;
  background-color: #ddd;
  font-weight: bold;
}
.rTableFoot {
  display: table-footer-group;
  font-weight: bold;
  background-color: #ddd;
}
.rTableBody {
  display: table-row-group;
}
.name-cell {
  width: 200px;
}
customer-cell {
  width: 300px;
}
.work-center-header {
  position: relative;
  font-size: 24px;
}
.export-button {
  position: absolute;
  right: 10px;
  top: 0;
  cursor: pointer;
}
.position-export-button {
  position: absolute;
  right: 50px;
  top: 0;
  cursor: pointer;
}
.complete-orders-button {
  position: absolute;
  right: 90px;
  top: 0;
  cursor: pointer;
}
.number-cell {
  text-align: right;
}
.text-cell {
  text-align: center;
}
.workcenter-filter {
  position: relative;
  height: 30px;
  border: 2px solid black;
  width: 100%;
}
.clickable {
  cursor: pointer;
}
.failed-box {
  background: red;
}

.empty-box {
  background: white;
}

.completed-box {
  background: rgb(57, 187, 57);
}

.uncompleted-box {
  background: rgb(248, 248, 106);
}
.products-column {
  opacity: 0.5;
}
.show-done {
  position: absolute;
  right: 250px;
  top: -15px;
}
</style>
